export const MINUTE_MS = 60 * 1000
export const SMALL_PROGRAM_MIN = 5
export const MIN_THREE_DOTS_WIDTH = 60
export const MAX_THREE_DOTS_WIDTH = 75
export const THREE_DOTS = '...'

interface GetProgramTitleParams {
  locked?: boolean
  lockedTitle?: string
  programTitle?: string
  fallbackTitle?: string
  programWidthInPixels: number
}

export const getProgramTitle = ({
  locked = false,
  lockedTitle = '',
  programTitle = '',
  fallbackTitle = '',
  programWidthInPixels,
}: GetProgramTitleParams): string => {
  // If program width is greater than maximum dots width, show full title
  if (programWidthInPixels > MAX_THREE_DOTS_WIDTH) {
    return locked ? lockedTitle : programTitle ? programTitle : fallbackTitle
  }

  // If program width is in range for ellipsis, show dots
  if (
    programWidthInPixels >= MIN_THREE_DOTS_WIDTH &&
    programWidthInPixels <= MAX_THREE_DOTS_WIDTH
  ) {
    return THREE_DOTS
  }

  // In all other cases show empty string
  return ''
}

interface GetProgramDescriptionParams {
  locked?: boolean
  title?: string
  isHovered?: boolean
  disabled?: boolean
  description?: string
  descriptionHover?: string
  isThreeDots?: boolean
}

export const getProgramDescription = ({
  locked = false,
  title = '',
  isHovered = false,
  disabled = false,
  description = '',
  descriptionHover = '',
  isThreeDots = false,
}: GetProgramDescriptionParams): string => {
  // If program is locked or has no title, show empty description
  if (locked || !title || isThreeDots) {
    return ''
  }

  // If program is hovered and not disabled, show hover description
  if (isHovered && !disabled) {
    return descriptionHover
  }

  // In all other cases show default description
  return description
}

interface GetIsRenderTitleParams {
  title?: string
  locked?: boolean
  programWidthInPixels: number
  minProgramPixels: number
}

export const getIsRenderTitle = ({
  title = '',
  locked = false,
  programWidthInPixels,
  minProgramPixels,
}: GetIsRenderTitleParams): boolean => {
  // If there is no title, don't render
  if (!title) {
    return false
  }

  // If program is locked, always render
  if (locked) {
    return true
  }

  // If program width is greater than minimum required width, render
  return (
    programWidthInPixels >= Math.max(minProgramPixels, MIN_THREE_DOTS_WIDTH)
  )
}

interface IsRenderCardParams {
  programWidthInPixels: number
  step: number
  startTimeLine: number
  stopTimeLine: number
  startMs: number
  stopMs: number
}
export const isRenderCard = ({
  programWidthInPixels,
  step,
  startTimeLine,
  stopTimeLine,
  startMs,
  stopMs,
}: IsRenderCardParams): boolean => {
  const isTooSmallCard = programWidthInPixels < step
  const overflow = startTimeLine > stopMs || stopTimeLine < startMs

  return !overflow && !isTooSmallCard
}
